import { Profile_profile } from '../../api/types/Profile';

/**
 * If profile has incomplete email verification request
 */
export const isVerifiedEmail = (
  { emailVerification }: Profile_profile,
) => !emailVerification || emailVerification.is_verified;
